/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentUseCasesControllerListDocumentTypesQueryResponse } from "../../models/documentUseCasesController/DocumentUseCasesControllerListDocumentTypes";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentUseCasesControllerListDocumentTypes } from "../../clients/document-use-casesService/documentUseCasesControllerListDocumentTypes";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentUseCasesControllerListDocumentTypesQueryKey = () => [{
  url: '/api/v1/documents/classifications/document-types'
}] as const;
export type DocumentUseCasesControllerListDocumentTypesQueryKey = ReturnType<typeof documentUseCasesControllerListDocumentTypesQueryKey>;
export function documentUseCasesControllerListDocumentTypesQueryOptions(config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentUseCasesControllerListDocumentTypesQueryKey();
  return queryOptions<DocumentUseCasesControllerListDocumentTypesQueryResponse, ResponseErrorConfig<Error>, DocumentUseCasesControllerListDocumentTypesQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentUseCasesControllerListDocumentTypes(config);
    }
  });
}

/**
 * @description The vocabulary the classifier answers from; the console's override picker filters these.
 * @summary List every active document type in the taxonomy
 * {@link /api/v1/documents/classifications/document-types}
 */
export function useDocumentUseCasesControllerListDocumentTypes<TData = DocumentUseCasesControllerListDocumentTypesQueryResponse, TQueryData = DocumentUseCasesControllerListDocumentTypesQueryResponse, TQueryKey extends QueryKey = DocumentUseCasesControllerListDocumentTypesQueryKey>(options: {
  query?: Partial<QueryObserverOptions<DocumentUseCasesControllerListDocumentTypesQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentUseCasesControllerListDocumentTypesQueryKey();
  const query = useQuery({
    ...documentUseCasesControllerListDocumentTypesQueryOptions(config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}